import * as Yup from 'yup';

export const CancelRequestFormSchema = Yup.object().shape({
  cancellationReason: Yup
    .string()
    .trim()
    .required('This field may not be blank')
    .default(''),
});
